import { Box, Flex } from '@mantine/core';
import { LogoExtendedIcon } from '../../../icons';

export const Footer = () => (
  <Box p={16} bg="violet.9">
    <Flex justify="center">
      <LogoExtendedIcon color="#fff" />
    </Flex>
  </Box>
);
